import { z } from 'zod';

export const ErrorSchema = z.object({
  type: z.string(),
  message: z.string(),
  message_template: z.string().optional(),
  context: z.record(z.string(), z.string()).optional(),
  validation_errors: z
    .object({
      loc: z.tuple([z.string(), z.number()]),
      msg: z.string(),
      type: z.string(),
    })
    .nullable(),
  code: z.number(),
});

/**
 * The envelope every Mint endpoint returns: a nullable `data` payload carrying
 * the page of items plus pagination metadata, and a nullable `error`.
 */
export const createResponseSchema = <D extends z.ZodType, A extends z.ZodType>(
  data: D,
  additional?: A,
) => {
  return z.object({
    data: z
      .object({
        items: z.array(data),
        message: z.string().nullable(),
        pageNumber: z.number().nullable(),
        itemsPerPage: z.number().nullable(),
        totalItems: z.number().nullable(),
        ordering: z.string().nullable(),
        additional: additional ?? z.null(),
      })
      .nullable(),
    error: ErrorSchema.nullable(),
  });
};

export const baseResponseSchema = createResponseSchema(z.any());
